import { useGateValue, useStatsigUser } from '@statsig/react-bindings';
import { useVercelOverrides } from './use-vercel-overrides';

export const FEATURES = {
  CAMPAIGNS: 'campaigns',
  SEGMENTS: 'segments',
  ADMIN_SETTINGS: 'enable_admin_settings',
  NEW_PROFILE_PAGE: 'new_profile_page',
  EMQ_SCORE_DASHBOARD: 'emq_score_dashboard',
  SENDLANE: 'sendlane',
  NEW_PROFILES_PAGE: 'new_profiles_page',
  ATTENTIVE: 'attentive'
} as const;

export type Feature = keyof typeof FEATURES;

export function useFeature(feature: Feature) {
  const { user: statsigUser } = useStatsigUser();
  const statsigValue = useGateValue(FEATURES[feature]);
  const overrides = useVercelOverrides();

  // Only use overrides for @getcontextual.io users
  const overrideValue = statsigUser.email?.endsWith('@getcontextual.io')
    ? overrides[FEATURES[feature]]
    : undefined;

  if (typeof overrideValue === 'boolean') {
    return overrideValue;
  }

  return statsigValue;
}
